export const safeParseCssStringAsInlineStyles = (cssString) => {
  try {
    const cssObject = {};
    const lines = cssString.split(";");

    lines.forEach((line) => {
      const [key, value] = line.split(":");
      if (key && value) {
        const formattedKey = key
          .trim()
          .replace(/-./g, (match) => match[1].toUpperCase());
        cssObject[formattedKey] = value.trim();
      }
    });
    return cssObject;
  } catch (error) {
    return {};
  }
};
